// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import iView from 'view-design'
import config from '@/config'
import i18n from '@/locale'
import 'jquery'
import moment from 'moment'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import '@/assets/icons/iconfont.css'
import 'view-design/dist/styles/iview.css'
import '@/libs/global'// 全局
import './libs/rem'
import JsEncrypt from 'jsencrypt'
import VueLazyload from 'vue-lazyload'
import './index.less'
import Print from 'vue-print-nb'
import * as echarts from 'echarts';
import 'view-ui-plus/dist/styles/viewuiplus.css'
/*
 import locale from 'element-ui/lib/locale/lang/en'
  import {Pagination, Dialog, Dropdown, Input, InputNumber, Radio, Checkbox,Select, OptionGroup, Option, Button, Table,
  TableColumn,Form, FormItem, Alert, Icon, Row, Col, Upload, Card, Main, Footer, Image, Loading, Tag,
  MessageBox, Message} from 'element-ui';
 import 'element-ui/lib/theme-chalk/index.css';
const list = [Pagination, Dropdown, Input, InputNumber, Dialog, Radio, Checkbox,Select, OptionGroup, Option, Button, Table,
  TableColumn,Form, FormItem, Alert, Icon, Row, Col, Upload, Card, Main, Footer, Image, Tag];
 Vue.prototype.$confirm = MessageBox.confirm;
 Vue.use(Loading.directive);
 Vue.prototype.$loading = Loading.service;
 Vue.prototype.$message = Message;
 list.map((e)=>{
 Vue.component(e.name,e)
 });
  */

const loadImage = require('./assets/images/loading.gif')
const errorImage = require('./assets/images/error.png')

Vue.use(VueLazyload, {
  preLoad: 2,
  error: errorImage,
  loading: loadImage,
  attempt: 1,
  adapter: {
    loaded ({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init }) {
      // 由于阿里cdn的图片在404状态下，依然返回了1x1像素，这里进行图片大小错误判断
      if (naturalHeight <= 1 && naturalWidth <= 1) {
        LoadedHandler(el)
      }
    },
    loading (listender, Init) {
      console.log('loading')
    },
    error (listender, Init) {
      console.log('error')
    }
  }
})

Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})

Vue.prototype.$echarts = echarts
Vue.prototype.$jsEncrypt = JsEncrypt
Vue.use(Print);
Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.prototype.$config = config
/* 定义一个全局过滤器实现日期格式化 */
Vue.filter('datafmt', function (el) {
  // 使用momentjs这个日期格式化类库实现日期的格式化功能
  return moment(el).format('YYYY-MM-DD HH:mm:ss')
})

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js